import React, { useState } from 'react';
import Modal from '../../../common/components/Modal/modal';
import KYCImage from '../../../images/icons/KYCComplete.svg';
import { navigate } from 'gatsby';
import { staticData } from 'gatsby-env-variables';
const PropertyThankUPage = ({ setShow, show }) => {
  return (
    <React.Fragment>
      <Modal show={show} noCloseBtn={false} setShow={setShow} dontClose={true}>
        <div className="w-full  px-4">
          <div className="w-full py-10">
            <p className="font-roboto font-medium mr-auto text text-green-600 text-xl"></p>
          </div>

          <div className="w-full">
            <p className="text-orange-600 font-roboto font-bold py-2 text-3xl">
              Thank You !
            </p>
            <p className="text-black-400 font-roboto font-normal py-2">
              You can update the details from the lead profile!
            </p>
            <p className="text-black-0 font-roboto font-normal my-4 text-sm">
              Our team will contact with you for any further details!
            </p>
            <div className="">
              <img className="mx-auto" src={KYCImage} />
            </div>
            <div className="">
              <button
                className="submitButton"
                onClick={() => navigate(staticData?.dashboardURl)}
              >
                {staticData?.redirectToDashboardDisplay}
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default PropertyThankUPage;
